module.exports = __webpack_public_path__ + "static/media/DWZ_05.b6a28b9f.jpg";